import React from 'react'
import SettingGeneralForm from '../components/setting/settingGeneralForm'

const SettingsGaneral = () => {
    return (
        <>
            <SettingGeneralForm />
        </>
    )
}

export default SettingsGaneral